import ar from './locale/ar';
import bg from './locale/bg';
import ca from './locale/ca';
import cs from './locale/cs';
import da from './locale/da';
import de from './locale/de';
import el from './locale/el';
import en from './locale/en';
import es from './locale/es';
import et from './locale/et';
import fa from './locale/fa';
import fi from './locale/fi';
import fr from './locale/fr';
import he from './locale/he';
import hi from './locale/hi';
import hu from './locale/hu';
import id from './locale/id';
import it from './locale/it';
import ja from './locale/ja';
import ko from './locale/ko';
import lv from './locale/lv';
import ml from './locale/ml';
import nl from './locale/nl';
import no from './locale/no';
import pl from './locale/pl';
import pt from './locale/pt';
import pt_BR from './locale/pt_BR';
import ro from './locale/ro';
import ru from './locale/ru';
import sk from './locale/sk';
import sr from './locale/sr';
import sv from './locale/sv';
import ta from './locale/ta';
import th from './locale/th';
import tr from './locale/tr';
import uk from './locale/uk';
import vi from './locale/vi';
import zh_CN from './locale/zh_CN';
import zh_TW from './locale/zh_TW';
import is from './locale/is';
import lt from './locale/lt';

// algorythmo: i18n-overlay-m0
// Deep-merge Algorythmo OS brand overrides on top of upstream locale strings.
// Only en and pt_BR are overridden in M0; other locales remain upstream as-is
// and will be addressed in M5/production (documented in engines/algorythmo/README.md).
import { deepMerge } from 'engines/algorythmo/app/javascript/i18n/deepMerge';
import enOverrides from 'engines/algorythmo/app/javascript/i18n/overrides/en.json';
import ptBROverrides from 'engines/algorythmo/app/javascript/i18n/overrides/pt_BR.json';

export default {
  ar,
  bg,
  ca,
  cs,
  da,
  de,
  el,
  en: deepMerge(en, enOverrides), // algorythmo: i18n-overlay-m0
  es,
  et,
  fa,
  fi,
  fr,
  he,
  hi,
  hu,
  id,
  it,
  ja,
  ko,
  ml,
  lv,
  nl,
  no,
  pl,
  pt_BR: deepMerge(pt_BR, ptBROverrides), // algorythmo: i18n-overlay-m0
  pt,
  ro,
  ru,
  sk,
  sr,
  sv,
  ta,
  th,
  tr,
  uk,
  vi,
  zh_CN,
  zh_TW,
  is,
  lt,
};
